import React from 'react';
import { BarChart, Bar, LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { useLanguage } from '../../../contexts/LanguageContext';

const ProfitabilityChart = ({ groups }) => {
  const { currentLanguage, t } = useLanguage();

  const chartData = groups?.map(group => ({
    name: group?.name?.substring(0, 20) || 'N/A',
    revenue: parseFloat(group?.revenue || 0),
    costs: parseFloat(group?.costs || 0),
    profit: parseFloat(group?.profit || 0),
    margin: parseFloat(group?.margin || 0)
  }));

  const formatCurrency = (value) => {
    return `${value?.toFixed(0)} MAD`;
  };

  return (
    <div className="bg-card rounded-lg border border-border shadow-warm p-4 md:p-6">
      <h3 className="text-lg font-semibold text-foreground mb-6">
        {t('financial.profitabilityAnalysis')}
      </h3>
      
      <div className="space-y-8">
        {/* Revenue vs Costs Bar Chart */}
        <div>
          <h4 className="text-sm font-medium text-muted-foreground mb-4">
            {currentLanguage === 'fr' ? 'Revenus vs Coûts par Groupe' : 'الإيرادات مقابل التكاليف حسب المجموعة'}
          </h4>
          <ResponsiveContainer width="100%" height={300}>
            <BarChart data={chartData}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="name" angle={-45} textAnchor="end" height={100} />
              <YAxis tickFormatter={formatCurrency} />
              <Tooltip formatter={(value) => formatCurrency(value)} />
              <Legend />
              <Bar 
                dataKey="revenue" 
                fill="#10b981" 
                name={currentLanguage === 'fr' ? 'Revenus' : 'الإيرادات'} 
              />
              <Bar 
                dataKey="costs" 
                fill="#ef4444" 
                name={currentLanguage === 'fr' ? 'Coûts' : 'التكاليف'} 
              />
            </BarChart>
          </ResponsiveContainer>
        </div>

        {/* Profit Margin Line Chart */}
        <div>
          <h4 className="text-sm font-medium text-muted-foreground mb-4">
            {currentLanguage === 'fr' ? 'Marge de Profit par Groupe' : 'هامش الربح حسب المجموعة'}
          </h4>
          <ResponsiveContainer width="100%" height={300}>
            <LineChart data={chartData}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="name" angle={-45} textAnchor="end" height={100} />
              <YAxis />
              <Tooltip formatter={(value) => `${value}%`} />
              <Legend />
              <Line 
                type="monotone" 
                dataKey="margin" 
                stroke="#3b82f6" 
                strokeWidth={2}
                name={currentLanguage === 'fr' ? 'Marge (%)' : 'الهامش (%)'}
              />
            </LineChart>
          </ResponsiveContainer>
        </div>
      </div>
    </div>
  );
};

export default ProfitabilityChart;